import { useEffect, useState } from "react";
import { Navigate, Route, Routes, useLocation, useNavigate } from "react-router-dom";
import { ApiError, getToken, ping } from "./api";
import Layout from "./components/Layout";
import Login from "./components/Login";
import Campaigns from "./pages/Campaigns";
import CampaignNew from "./pages/CampaignNew";
import CampaignDetail from "./pages/CampaignDetail";
import Contacts from "./pages/Contacts";
import ContactDetailPage from "./pages/ContactDetail";
import Inbox from "./pages/Inbox";
import ThreadDetail from "./pages/ThreadDetail";
import Metrics from "./pages/Metrics";

type AuthState = "checking" | "ok" | "needs_login";

export default function App() {
  const [auth, setAuth] = useState<AuthState>("checking");
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    let cancelled = false;
    const check = async () => {
      if (!getToken()) {
        if (!cancelled) setAuth("needs_login");
        return;
      }
      try {
        await ping();
        if (!cancelled) setAuth("ok");
      } catch (err) {
        if (cancelled) return;
        if (err instanceof ApiError && err.status === 401) setAuth("needs_login");
        else setAuth("needs_login");
      }
    };
    check();
    return () => {
      cancelled = true;
    };
  }, []);

  if (auth === "checking") {
    return (
      <div className="flex h-full items-center justify-center text-ink-500 text-sm">
        checking auth…
      </div>
    );
  }

  if (auth === "needs_login") {
    return <Login onAuthed={() => { setAuth("ok"); if (location.pathname === "/") navigate("/campaigns"); }} />;
  }

  return (
    <Layout>
      <Routes>
        <Route path="/" element={<Navigate to="/campaigns" replace />} />
        <Route path="/campaigns" element={<Campaigns />} />
        <Route path="/campaigns/new" element={<CampaignNew />} />
        <Route path="/campaigns/:id" element={<CampaignDetail />} />
        <Route path="/contacts" element={<Contacts />} />
        <Route path="/contacts/:id" element={<ContactDetailPage />} />
        <Route path="/inbox" element={<Inbox />} />
        <Route path="/threads/:id" element={<ThreadDetail />} />
        <Route path="/metrics" element={<Metrics />} />
        <Route path="*" element={<Navigate to="/campaigns" replace />} />
      </Routes>
    </Layout>
  );
}
